import React from "react";
import { InterviewSidebarSection } from "../Components/InterviewSidebarSection";
import { RowWithSingleField } from "../Components/SidebarComponents";

export const InterviewSidebarContractConsent = ({ contractConsent, ...props }) => {
    return (
        <InterviewSidebarSection title="Contract Consent" {...props}>
            <>
                <div className="mini-section">
                    {/* <div className="row">
                        <h4>{"Contract Consent"}</h4>
                    </div> */}
                    {contractConsent?.hasConsented != undefined && (
                        <RowWithSingleField
                            title="Contract consented"
                            value={contractConsent.hasConsented ? "Yes" : "No"}
                        />
                    )}
                    {contractConsent?.hasMobilePhoneAvailable != undefined && (
                        <RowWithSingleField
                            title="Mobile phone available"
                            value={contractConsent.hasMobilePhoneAvailable ? "Yes" : "No"}
                        />
                    )}
                    {contractConsent?.hasMobilePhoneAvailable && (
                        <RowWithSingleField title="Mobile" value={contractConsent.mobilePhoneNumber} />
                    )}
                    {contractConsent?.hasContractBeenPrinted != undefined && (
                        <RowWithSingleField
                            title="Contract printed"
                            value={contractConsent.hasContractBeenPrinted ? "Yes" : "No"}
                        />
                    )}
                </div>
            </>
        </InterviewSidebarSection>
    );
};
